import React, { useState } from 'react'
import moment from 'moment';

const TestData = () => {
    const [ testData, setTestData ] = useState(localStorage.getItem('biteship_test_data')||'notActive') 

    if (testData === 'notActive') {
        return null
    }

    if (testData === 'active') {
        return (
            <div className="bg-warning rounded shadow px-4 py-3 mb-3 text-center">
                <div className="bold text-white"><b>Anda sedang berada mode testing</b></div>
            </div>
        )
    } else {
        return null
    }
};

export default TestData;
